import { Controller } from "@hotwired/stimulus"
import { smartMatch } from "../../utils/smart_search"

export default class extends Controller {
  static targets = ["input", "list", "row", "checkbox", "counter"]

  filter() {
    const query = this.inputTarget.value

    this.rowTargets.forEach((row) => {
      const name = row.dataset.studentName || ""
      row.style.display = smartMatch(name, query) ? "" : "none"
    })
  }

  selectAll() {
    this.checkboxTargets.forEach((cb) => {
      if (cb.closest("[data-student-assignment-filter-target='row']").style.display !== "none") {
        cb.checked = true
      }
    })
    this.updateCounter()
  }

  deselectAll() {
    this.checkboxTargets.forEach((cb) => {
      cb.checked = false
    })
    this.updateCounter()
  }

  updateCounter() {
    const count = this.checkboxTargets.filter((cb) => cb.checked).length
    if (this.hasCounterTarget) {
      this.counterTarget.textContent = `${count} selected`
    }
  }
}
